import type { FaireProductEntity } from "../../entity_types/product";

export const p_7e5577m98x: FaireProductEntity = {
  token: "p_7e5577m98x",
  type: "product",
  name: "Touchy Coffee Enamel Mug",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl: "https://cdn.faire.com/fastly/29c0bf7da42b61b913eae05d6171b51ee98016daf79182fc44c774c9303662ff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16c2b5c94dfbb0fe063760593c86951198ce1e0f694d07830328209b66f948e1.png"
  ],
  priceDollars: 16.8,
  description: "• Material: Enameled Steel\n• Art by: Felicity Jones\n• Printed by: Emalco Enamelware\n• Size: 12 oz\n\nA Touchy Coffee enamel mug to drink your Touchy Coffee from! Designed in house by our very own Felicity Jones. A silly lil mug complete with seven colors (chocolate brown exterior, baby pink interior, green rim, blue handle). Front, back and bottom artwork including a phrase we live by: \"COFFEE it's not just for breakfast anymore.\"\n\nLight + durable, this mug is the perfect companion on all of your adventures. Oven + dishwasher safe. 12oz. Made by Emalco Enamelware in Poland.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:43.452Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
